import { FieldInputType } from '../../../enums/fields/field-input-type.enum';
import { Status } from '../../../enums/status/status.enum';
export class VehicleInformation {
    static EDITABLE_FIELDS = {
        informed_plate: [Status.NEW, Status.IN_PROGRESS, Status.COMPLETED, Status.CANCELLED, Status.REOPENED],
        vin: [Status.COMPLETED, Status.CANCELLED],
        odometer: [Status.COMPLETED, Status.CANCELLED],
        front_plate: [Status.COMPLETED, Status.CANCELLED],
        rear_plate: [Status.COMPLETED, Status.CANCELLED],
        brand: [Status.COMPLETED, Status.CANCELLED],
        model: [Status.COMPLETED, Status.CANCELLED],
        year: [Status.COMPLETED, Status.CANCELLED],
        color: [Status.COMPLETED, Status.CANCELLED],
        information_bodywork: [Status.COMPLETED, Status.CANCELLED],
        pickup_box_type: [Status.COMPLETED, Status.CANCELLED],
        information_country: [Status.COMPLETED, Status.CANCELLED]
    };
    vin;
    odometer;
    front_plate;
    rear_plate;
    informed_plate;
    brand;
    model;
    year;
    color;
    bodywork;
    country;
    pickupBoxType;
    constructor(fraudSummary, plate) {
        this.vin = {
            label: 'vin',
            type: 'string',
            required: false,
            properties: ['detected_vin_text'],
            value: fraudSummary?.vinDetection?.detail?.detected_vin_text,
            image: fraudSummary?.vinDetection?.detail?.image ?? null,
            formType: FieldInputType.Table
        };
        this.odometer = {
            label: 'odometer',
            type: 'number',
            required: false,
            properties: ['detected_odometer_text'],
            value: fraudSummary?.odometer?.detail?.detected_odometer_text,
            image: fraudSummary?.odometer?.detail?.image ?? null,
            unit: {
                label: 'odometer_unit',
                type: 'list',
                required: false,
                properties: ['odometer_unit'],
                value: fraudSummary?.odometer?.detail?.odometer_unit ?? 'Km',
                formType: FieldInputType.Table
            },
            formType: FieldInputType.Table
        };
        const front = fraudSummary?.plateDetection?.detail?.find(({ type }) => type === 'front');
        const rear = fraudSummary?.plateDetection?.detail?.find(({ type }) => type === 'rear');
        this.front_plate = {
            label: 'front_plate',
            type: 'string',
            required: false,
            properties: ['front_plate'],
            value: front?.detected_plate_text,
            image: front?.image || null,
            formType: FieldInputType.Table
        };
        this.rear_plate = {
            label: 'rear_plate',
            type: 'string',
            required: false,
            properties: ['rear_plate'],
            value: rear?.detected_plate_text,
            image: rear?.image || null,
            formType: FieldInputType.Table
        };
        this.informed_plate = {
            label: 'informed_plate',
            type: 'string',
            required: false,
            properties: ['informed_plate'],
            value: plate,
            formType: FieldInputType.Table
        };
        this.brand = {
            label: 'brand',
            type: 'string',
            required: false,
            properties: ['decoded_brand'],
            value: fraudSummary?.vinDetection?.detail?.decoded_brand,
            formType: FieldInputType.Table
        };
        this.model = {
            label: 'model',
            type: 'string',
            required: false,
            properties: ['decoded_model'],
            value: fraudSummary?.vinDetection?.detail?.decoded_model,
            formType: FieldInputType.Table
        };
        this.year = {
            label: 'year',
            type: 'number',
            required: false,
            properties: ['decoded_year'],
            value: fraudSummary?.vinDetection?.detail?.decoded_year,
            formType: FieldInputType.Table
        };
        this.color = {
            label: 'color',
            type: 'string',
            required: false,
            properties: ['color'],
            value: fraudSummary?.colorDetection?.color,
            formType: FieldInputType.Table
        };
        this.bodywork = {
            label: 'information_bodywork',
            type: 'list',
            required: false,
            properties: ['decoded_body_type'],
            value: fraudSummary?.vinDetection?.detail?.decoded_body_type,
            formType: FieldInputType.Table
        };
        this.pickupBoxType = {
            label: 'pickup_box_type',
            type: 'list',
            required: false,
            properties: ['decoded_pickup_box_type'],
            value: fraudSummary?.vinDetection?.detail?.decoded_pickup_box_type,
            formType: FieldInputType.Table
        };
        this.country = {
            label: 'information_country',
            type: 'string',
            required: false,
            properties: ['decoded_country'],
            value: fraudSummary?.vinDetection?.detail?.decoded_country,
            formType: FieldInputType.Table
        };
    }
}
